import { Component, OnDestroy, OnInit } from '@angular/core';
import { LIFERAY_WEB_CONSTANT } from '../../../utils/liferay.constant';
import { LiferayService } from '../../../services/liferay/liferay.service';
import { Subject, takeUntil } from 'rxjs';
import { IPageContent, IWebContant, IWebContantArticleDisclosures } from '../../../services/liferay/liferay.interface';
import { trackByIndex } from '../../../utils/helper';

@Component({
  selector: 'app-disclosure',
  templateUrl: './disclosure.component.html',
  styleUrl: './disclosure.component.scss'
})
export class DisclosureComponent implements OnInit, OnDestroy {
  disclosureContent: string[] = [];
  cleaner$ = new Subject<void>();
  trackByIndex = trackByIndex;
  constructor(private liferayService: LiferayService) { }
  ngOnInit(): void {
    this.getDisclosureWebContent()
  }

  /**
     * @description Get Disclosure Web Content
     */
  getDisclosureWebContent(): void {
    const content = LIFERAY_WEB_CONSTANT.disclosure;
    this.liferayService.getWebContent<IWebContantArticleDisclosures>(content.type, content.id).pipe(takeUntil(this.cleaner$)).subscribe({
      next: (data: IWebContant<IWebContantArticleDisclosures>) => {
        this.liferayService.addLiferayContent<IWebContantArticleDisclosures>(content.type, content.id, data);
        const disclosureData = data.value['page-content'];
        this.disclosureContent = Object.values(disclosureData).filter(paragraph => paragraph);
      }
    });
  }


  ngOnDestroy(): void {
    this.cleaner$.next();
    this.cleaner$.complete();
  }
}
